import { context, SpanStatusCode, trace } from '@opentelemetry/api'
import React, { useEffect } from 'react'
import { NavigationType } from 'react-router-dom'

import { ReactRouterV6RoutesProps } from './types'

/**
 * This is a React component that uses tracing to log route changes in a web application.
 * @param {ReactRouterV6RoutesProps} props - ReactRouterV6RoutesProps object that contains the
 * properties passed to the RoutesWrapper component.
 */
export function RoutesWrapper(props: ReactRouterV6RoutesProps) {
  const { location, navigationType } = props

  useEffect(() => {
    if (navigationType === NavigationType.Push || navigationType === NavigationType.Pop) {
      const tracer = trace.getTracer('@msdk/charybui')
      const span = tracer.startSpan('routeChange', {
        startTime: Date.now(),
        attributes: {
          url: window.location?.href,
        },
      })
      context.with(trace.setSpan(context.active(), span), () => {
        span.setStatus({
          code: SpanStatusCode.OK,
          message: '🚀',
        })
        span.end()
      })
    }
  }, [location, navigationType])

  return <>{props.children}</>
}
